import { XSquare } from "@phosphor-icons/react";
import React from "react";
import ReactDOM from "react-dom";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
};

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, title }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${
        isOpen ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
      onClick={onClose}
    >
      <div
        className="custom-scroll relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-lg bg-white p-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <XSquare
            className="absolute right-4 top-4 text-gray-600 hover:text-brandRed-500"
            weight="fill"
            size={30}
          />
        </button>

        {/* Header */}
        {title && <h2 className="mb-4 text-xl font-semibold">{title}</h2>}

        {/* Body */}
        <div>{children}</div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
